<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    UPN QR
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

<!--                <pre v-if="value">{{value + (value.length + 0) + '\n'}}</pre>-->

                <VueQrcode v-if="value" :value="value + (value.length + 0) + '\n'" :size="size" errorCorrectionLevel="M" />


                <b-form-group
                        id="name"
                        label="Ime in priimek kupca"
                        label-for="name">
                    <b-form-input id="name" v-model="name" trim></b-form-input>
                </b-form-group>

              <b-form-group
                  id="name"
                  label="Ulica in hišna številka"
                  label-for="name">
                <b-form-input id="name" v-model="line1" trim></b-form-input>
              </b-form-group>

              <b-form-group
                  id="name"
                  label="Pošta in poštna številka"
                  label-for="name">
                <b-form-input id="name" v-model="line2" trim></b-form-input>
              </b-form-group>

            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteProjectConfirmation()"><i class="fa fa-trash"></i>
                        Izbriši
                        projekt
                    </button>

                    <button type="submit" @click="getQRcodeString()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Ustvari UPN QR kodo
                    </button>



                </div>

                <div>



                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import VueQrcode from "vue-qrcode";

  export default {
    name: 'EditProject',
    components: {
      vSelect,
      VueQrcode,
    },
    data () {
      return {
        name: '',
        line1: '',
        line2: '',
        project: {
          id: null,
          name: '',
          line1: '',
          line2: '',
          //projectManager: null
        },
        users: [],
        id: this.$route.params.id,
        editMode: false,
        size: 300,
        //value: "UPNQR\n\n\n\n\nZavod Dobra pot\nBarka 31\n6217 Vremski Britof\n" + "00000000010\n\n\nOTHR\nPrirocnik Otip narave\n" + "\n" + "SI56101000054179345" + "\nSI00" + this.moment().format('DDMMYYYY') + "00000\n" + " " + "\n" + " " + "\n" + "\n201\n",
        value: null
      }
    },
    firestore () {
      if (this.id) {
        return {
          project: db.collection('projects').doc(this.id),
          // users: db.collection('users')
        }
      } else {
        return {
          // users: db.collection('users')
        }
      }
    },
    computed: {

    },
    mounted () {

      if (this.id) {
        this.editMode = true
      } else {
        this.editMode = false
      }

    },
    methods: {
      getQRcodeString() {
        this.value = 'UPNQR\n\n\n\n\n' +
            this.name + '\n' +
            this.line1 + '\n' +
            this.line2 + '\n' +
            '00000002200\n' +
            '\n' +
            '\n' +
            'OTHR\n' +
            'Prirocnik Otip narave\n'+
            this.moment().add(5, 'days').format('DDMMYYYY') + '\n'+
            'SI56101000054179345\n'+
            'SI00' + this.moment().format('DDMMYYYYHHmm') + '\n' +
            'Zavod Dobra pot\n' +
            'Barka 31\n' +
            '6217 Vremski Britof\n'
      },

      updateProject (id) {
        const _this = this
        const currentProject = db.collection('projects').doc(this.id)

        return currentProject.update({
          name: _this.project.name,
          //projectManager: _this.project.projectManager,
          active: _this.project.active,
          updatedAt: new Date(),
          updatedBy: JSON.parse(sessionStorage.getItem('DP_user')).id,
          createdAt: _this.project.createdAt,
          createdBy: _this.project.createdBy
        })
          .then(function () {
            _this.$router.push('/projekti')
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating project: ', error)
          })

      },

      addProject () {
        const _this = this

        let ref = db.collection('projects').doc()
        ref.set({id: ref.id}) // set new document ID
          .then(() => {  // fetch the doc again and show its data
            ref.get().then(doc => {

              _this.id = doc.data().id
              _this.project.createdAt = new Date()
              _this.project.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id
              _this.updateProject()

            })
          })
      },
      deleteProjectConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati projekt ' + _this.project.name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteProject()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteProject () {
        const _this = this

        db.collection('projects').doc(_this.id).delete()
          .then(function () {
            _this.$store.dispatch('retrieveEvents', true).then(() => {
              _this.$router.push('/projekti')
            })
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/UPNqr.vue